import React from "react";
import { useSelector } from "react-redux";

import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import MDBadge from "components/MDBadge";

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import Moment from "react-moment";
import DataTable from "examples/Tables/DataTable";

import EditContract from "../EditContract";

// Material Dashboard 2 PRO React contexts
import { useMaterialUIController } from "context";

import { canEditOrder } from "../../../utils/permissions";

export default function ContractTable({ device, user }) {
  const currentOrder = useSelector((state) => state.orders.currentOrder);
  const canEdit = canEditOrder(user, currentOrder);
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  const contractColumns = [
    { Header: "État du contrat", accessor: "contract", align: "center" },
    { Header: "Signature", accessor: "signature", align: "center" },
    { Header: "Date de début de contrat", accessor: "informed", align: "center" },
  ];
  const contractRows = [
    {
      contract: (
        <MDBox display="flex" alignItems="center" lineHeight={1}>
          <MDBox lineHeight={1}>
            <MDBox ml={-1}>
              <MDBadge
                badgeContent={
                  device && device.maintenance_contract === null
                    ? "Non spécifié"
                    : device.maintenance_contract
                }
                color={
                  device && device.maintenance_contract === null
                    ? !darkMode
                      ? "dark"
                      : "light"
                    : device && device.maintenance_contract === "Acceptation"
                    ? "success"
                    : device && device.maintenance_contract === "Refus"
                    ? "error"
                    : device && device.maintenance_contract === "Continuité" && "success"
                }
                variant="gradient"
                size="lg"
              />
            </MDBox>
          </MDBox>
        </MDBox>
      ),
      signature: (
        <MDBox display="flex" alignItems="center" lineHeight={1}>
          {device && device.maintenance_contract_signature_date !== null ? (
            <MDBox lineHeight={1}>
              <MDTypography variant="caption">Signé le</MDTypography>
              <MDTypography display="block" variant="string" fontWeight="medium">
                <Moment format="DD/MM/YYYY">
                  {device && device.maintenance_contract_signature_date}
                </Moment>
              </MDTypography>
            </MDBox>
          ) : (
            <MDTypography display="block" variant="caption" color="warning" fontWeight="medium">
              Non signé
            </MDTypography>
          )}
        </MDBox>
      ),
      informed: (
        <MDBox display="flex" alignItems="center" lineHeight={1}>
          {device && device.maintenance_contract_responsible_informed_date !== null ? (
            <MDBox lineHeight={1}>
              <MDTypography variant="caption">Informé le</MDTypography>
              <MDTypography display="block" variant="string" fontWeight="medium">
                <Moment format="DD/MM/YYYY">
                  {device && device.maintenance_contract_responsible_informed_date}
                </Moment>
              </MDTypography>
            </MDBox>
          ) : (
            <MDTypography display="block" variant="caption" color="warning" fontWeight="medium">
              Non informé
            </MDTypography>
          )}
        </MDBox>
      ),
    },
  ];
  return (
    <Grid item lg={12} md={12} sm={12} xs={12} height="100%">
      <Card sx={{ height: "100%" }}>
        <MDBox
          mx={2}
          mt={-3}
          py={1.5}
          px={2}
          variant="gradient"
          borderRadius="lg"
          sx={{
            background: !darkMode ? "linear-gradient(195deg, #364c70, #273956)" : "white",
            boxShadow: darkMode ? "0 1px 4px 1px white" : "0 1px 4px 1px #344767",
            display: "flex",
            verticalAlign: "middle",
          }}
        >
          <MDTypography
            variant="h5"
            style={{
              width: "75%",
              lineHeight: "2.4rem",
              display: "tableCell",
              verticalAlign: "middle",
            }}
            color={darkMode ? "inherit" : "white"}
          >
            Contrat de maintenance
          </MDTypography>
          {canEdit && (
              <Grid style={{ textAlign: "right", width: "25%" }}>
                <EditContract device={device} edit={true} renderStep={0} />
              </Grid>
            )}
        </MDBox>
        <MDBox
          pt={0.75}
          sx={{
            height: "100%",
            "div.MuiTableContainer-root": {
              height: "100%",
              display: "flex",
            },
          }}
        >
          <DataTable
            table={{ columns: contractColumns, rows: contractRows }}
            isSorted={false}
            entriesPerPage={false}
            showTotalEntries={false}
            noEndBorder
          />
        </MDBox>
      </Card>
    </Grid>
  );
}
